import Vue from 'vue'
import Router from 'vue-router'
import index from '@/view/index'
import main from '@/view/main'
import http from '../helper/http';
Vue.use(Router)

//路由定义

let router = new Router({
  mode: 'hash',
  routes: [{
    path: '/',
    redirect: '/main'
  },
  {
    path: '/index',
    name: 'index',
    component: index,
    children: [{
      path: '/main',
      name: '活动设置',
      component: resolve => require(['@/view/main.vue'], resolve)
    }]
  }, {
    path: '/login',
    name: 'login',
    meta: {
      title: '无权限',
    },
    component: resolve => require(['@/view/login.vue'], resolve)
  }
  ]
})


async function getRouters() {
  let menuList = await http.get("/menu/getmenulist");
  let temp = new Vue({
    router
  });
  let newRoutes = [];
  if (menuList == null || menuList.length == 0) return;
  menuList.forEach(item => {
    let childList = [];
    item.child.forEach(citem => {
      let obj = {
        path: citem.url,
        name: citem.menuname,
        children: [],
        meta: {
          title: citem.menuname,
        },
        component: resolve => require(['@/view' + citem.url + '.vue'], resolve)
      }
      if (citem.child.length > 0) {
        citem.child.forEach(ccitem => {
          let cobj = {
            path: ccitem.url,
            name: ccitem.menuname,
            meta: {
              title: ccitem.menuname,
            },
            component: resolve => require(['@/view' + ccitem.url + '.vue'], resolve)
          }
          childList.push(cobj);
        })
      }
      childList.push(obj)
    })
    newRoutes.push({
      path: item.url,
      name: item.name,
      component: index,
      children: childList
    })
  })
  if (temp.$router.options.routes.length < 10)
    temp.$router.addRoutes(newRoutes);
}

export default {
  router,
  getRouters
};



// WEBPACK FOOTER //
// ./src/router/index.js